<!--  -->
<template>
  <div class=''>

    <el-row type="flex" class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>产品</span>
          </div>

          <div class='content'>
            <div class="content-action">
              <a @click="editProductInfoDialogVisible = true">编辑</a>
              <a @click="editProductGroupDialogVisible = true;editPGFlag=false;new_pg={}">新增产品组</a>
            </div>
            <div class="product-introduce">
              {{productHtml}}
            </div>
            <div class="product-group">

              <div class="product-class-item" v-for="(item,index) in pgs" @mouseenter="inGroup(item,index)"
                @mouseleave="leaveGroup(item,index)">
                <div class="top-ProductItem">
                  <a>
                    <h1>
                      {{item.pGName}}
                    </h1>
                  </a>
                  <h2>
                    {{item.pGEnglishTitle}}
                  </h2>
                </div>
                <p class="middle-productItem">
                  {{item.pGFTitle}}
                </p>
                <div class="bottom-productItem">
                  <ul>
                    <li v-for="(product,pIndex) in item.ps" @mouseenter="inProduct(product,pIndex)"
                      @mouseleave="leaveProduct(product,pIndex)">
                      <div class="product">
                        <a> {{product.pName}}</a>
                        <div class="product-action" v-if="product.in">
                          <a @click="getProductContent(product)">编辑</a><a @click="delP(product)">删除</a><a
                            @click="addChild(product,item)">新增子产品</a>
                        </div>
                      </div>
                      <ul v-if="product.cs !== undefined" style="margin-left: 10px">
                        <li v-for="(c,cindex) in product.cs" style="margin-top:1px;">
                          <div class="product">
                            <a> {{c.pName}}</a>
                            <div class="product-action" v-if="product.in">
                              <a @click="getProductContent(c)">编辑</a><a @click="delP(c)">删除</a><a
                            </div>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div v-bind:class="[item.in ? '' : 'action-hidden', 'Item-add']">
                    <a @click="editProductDialogVisible = true;newPPG=item;editP={p:{},content:''}"> - 新增产品 -</a>
                  </div>
                </div>
                <img :src="item.pGPic">
                <div class="item-action" v-if="item.in!=null && item.in">
                  <a
                    @click="editProductGroupDialogVisible = true;new_pg = JSON.parse(JSON.stringify(item));editPGFlag=true">
                    编辑
                  </a>
                  <a @click="delPG(item)">
                    删除
                  </a>
                </div>
              </div>

            </div>
            <!-- <div class="light-packaging-wrap">
              <div class="light-packaging-title-wrap">
                <h1>轻包装产品</h1>
              </div>

              <div class="light-packaging-item" v-for="(item, index) in lpps" :key="index">
                <h1 class="light-packaging-item-title">{{item.pName}}</h1>
                <div class="light-packaging-item-content">
                  <div class="light-packaging-item-content-l">
                    <a :href="item.pPic"><img :src="item.pPic"></a>
                  </div>

                  <div class="light-packaging-item-content-r">
                    <div>
                      <p style="font-weight: bold;color: #314478;">■用途：</p>
                      <p>{{item.pUse}}</p>
                    </div>

                    <div>
                      <p style="font-weight: bold;color: #314478;">■密封方法：</p>
                      <p>{{item.pFenkou}}</p>
                    </div>
                  </div>
                </div>
                <div class="light-packaging-item-action">
                  <a @click="getProductContent(item)">编辑</a>
                  <a @click="delP(item)">删除</a>
                </div>
              </div> -->
            <!-- </div> -->

          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="产品简介" :visible.sync="editProductInfoDialogVisible" width="1050px">
      <el-form>
        <el-form-item label="产品简介" label-width="180px">
          <el-input autocomplete="off" clearable v-model="productHtml" type="textarea" rows="5"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editProductInfoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="uploadHtmlProduct">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增产品组" :visible.sync="editProductGroupDialogVisible" width="1070px">
      <el-form>
        <el-form-item label="产品组名称" label-width="180px" label-position="left">
          <el-input autocomplete="off" v-model="new_pg.pGName" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品组英文简称" label-width="180px">
          <el-input autocomplete="off" v-model="new_pg.pGEnglishTitle" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品组序号" label-width="180px">
          <el-input autocomplete="off" v-model="new_pg.index" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品组路由名称" label-width="180px">
          <el-input autocomplete="off" v-model="new_pg.pGLink" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品组图片地址" label-width="180px">
          <el-input autocomplete="off" v-model="new_pg.pGPic" clearable></el-input>
        </el-form-item>

        <el-form-item label="产品组副标题" label-width="180px">
          <el-input autocomplete="off" v-model="new_pg.pGFTitle" clearable></el-input>
        </el-form-item>

        <el-form-item label="产品组简介" label-width="180px">
          <el-input autocomplete="off" clearable type="textarea" v-model="new_pg.pGRemark" rows="5"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editProductGroupDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editNewPg">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增产品" :visible.sync="editProductDialogVisible" width="1070px">

      <el-row :gutter="20" style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3" style="text-align: right;">
          产品名称
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入内容" v-model="editP.p.pName" clearable>
          </el-input>
        </el-col>
        <el-col :span="3" style="text-align: right;">
          产品副标题
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入内容" v-model="editP.p.pFTitle" clearable>
          </el-input>
        </el-col>

        <el-col :span="3" style="text-align: right;">
          产品路由名称
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入内容" v-model="editP.p.pLink" clearable>
          </el-input>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3" style="text-align: right;">
          产品图片地址
        </el-col>
        <el-col :span="21">
          <el-input placeholder="请输入内容" v-model="editP.p.pPic" clearable>
          </el-input>
        </el-col>

      </el-row>

      <el-row :gutter="20" style="align-items: center; line-height: 40px;margin-bottom: 20px;">
        <el-col :span="3" style="text-align: right;">
          产品简介
        </el-col>
        <el-col :span="21">
          <el-input autocomplete="off" v-model="editP.p.pRemark" clearable type="textarea" rows="5">
          </el-input>
        </el-col>

      </el-row>
      产品详情

      <editor :api-key="editorConf.kkey" :init="editorConf" v-model="editP.content"></editor>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editProductDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  var Editor = require("@tinymce/tinymce-vue").default;
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      editor: Editor // <- Important part
    },
    data() {
      //这里存放数据
      return {
        editPGFlag: false,
        editPConten: "",
        editP: { p: {}, content: '' },
        newPPG: {},
        new_pg: {},
        productHtml: "",
        editProductDialogVisible: false,
        editProductInfoDialogVisible: false,
        editProductGroupDialogVisible: false,
        selectItem: {},
        pgs: [],
        lpps: []
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      addChild(p, pg) {
        this.editP = {
          p: {
            type: 3,
            pFLink: p.pLink,
            pGLink: p.pGLink,
          },
          content: ''
        }
        this.newPPG = pg
        this.editProductDialogVisible = true;
      },
      delP(p) {
        var that = this;
        this.$alert("是否删除该产品", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            if (action == "confirm") {
              var url = "/api/admin/product/delP";
              this.$request.post({
                url: url,
                params: p,
                callback: {
                  success: function (data) {
                    if (p.pGLink === undefined) {
                      that.lpps = data.data;
                    } else {
                      that.pgs = data.data;
                    }

                  },
                  err: function (err) {
                    console.log(err);
                  }
                }
              });

            }
          }
        });
      }, delPG(pg) {
        var that = this;
        this.$alert("是否删除该产品组", "提示", {
          confirmButtonText: "确定",
          callback: action => {

            if (action == "confirm") {
              var url = "/api/admin/product/delPG";
              this.$request.post({
                url: url,
                params: pg,
                callback: {
                  success: function (data) {
                    that.pgs = data.data;
                  },
                  err: function (err) {
                    console.log(err);
                  }
                }
              });
            }


          }
        });
      },
      getProductContent(product) {
        var that = this;
        that.newPPG = undefined;
        this.$request.get({
          url: "/api/pageData/product/content",
          params: { pLink: product.pLink, pGLink: product.pGLink },
          callback: {
            success: function (data) {
              that.editP = data.data;
              if (that.editP.p.pGLink == undefined) {
                if (that.editP.p.pUse !== undefined) {
                  that.pUse = that.editP.p.pUse.split('·');
                } else {
                  that.pUse = []
                }
                if (that.editP.p.pFenkou !== undefined) {
                  that.pFenkou = that.editP.p.pFenkou.split('·');
                } else {
                  that.pFenkou = []
                }
                // that.editLPProductDialogVisible = true;
              } else {
                that.editProductDialogVisible = true;
              }
            },
            err: function (err) {
              console.log(err);
            }
          }
        });
      },
      editProduct() {
        var that = this;
        var url = "";
        if (that.newPPG == undefined) {
          if (that.editP.p.pGLink == undefined) {
            that.editP.p.pUse = that.pUse.join('·');
            that.editP.p.pFenkou = that.pFenkou.join('·');
            url = "/api/admin/product/addP";
          } else {
            url = "/api/admin/product/editP";
          }
        } else {
          url = "/api/admin/product/addP";
          that.editP.p.pGLink = that.newPPG.pGLink;
        }
        this.$request.post({
          url: url,
          params: that.editP,
          callback: {
            success: function (data) {
              if (that.editProductDialogVisible) {
                that.editProductDialogVisible = false;
                that.pgs = data.data;
                // } else if (that.editLPProductDialogVisible) {
                //   that.lpps = data.data;
                //   that.editLPProductDialogVisible = false;
              }
            },
            err: function (err) {
              console.log(err);
            }
          }
        });
      },
      editNewPg() {
        var that = this;
        var url = "";
        if (that.editPGFlag) {
          url = "/api/admin/product/editPG";
        } else {
          url = "/api/admin/product/addPG";
        }
        this.$request.post({
          url: url,
          params: that.new_pg,
          callback: {
            success: function (data) {
              that.editProductGroupDialogVisible = false;
              that.pgs = data.data;
            },
            err: function (err) {
              console.log(err);
            }
          }
        });
      },
      uploadHtmlProduct() {
        var that = this;
        this.$request.post({
          url: "/api/admin/cover/product_t",
          params: { html: that.productHtml },
          callback: {
            success: function (data) {
              that.editProductInfoDialogVisible = false;
              that.productHtml = data.data;
            },
            err: function (err) {
              console.log(err);
            }
          }
        });
      },
      inGroup(group, index) {
        group.in = true;
      },
      leaveGroup(group, index) {
        group.in = false;
      },
      inProduct(product, pIndex) {
        product.in = true;
      },
      leaveProduct(product, pIndex) {
        product.in = false;
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      var that = this;
      this.$request.get({
        url: "/api/pageData/admin/product",
        callback: {
          success: function (data) {
            that.pgs = data.data.pgs;
            that.lpps = data.data.lpps;
            that.productHtml = data.data.product;
          },
          err: function (err) {
            console.log(err);
          }
        }
      });
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style scoped>
  @import url("../../assets/css/all.css");

  a {
    cursor: pointer;
  }

  .product {
    position: relative;
  }

  .light-packaging-wrap {
    margin-top: 40px;
  }

  .light-packaging-item-action {
    position: absolute;
    top: 5px;
    right: 0;
  }

  .light-packaging-item-action a {
    margin-right: 10px;
    padding: 5px;
    color: cornflowerblue;
    font-size: 93%;
  }

  .product-action {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    background-color: rgb(0, 0, 0, 0.5);
  }

  .product-action a {
    color: white;
    margin-left: 5px;
  }

  .content {
    padding-bottom: 20px;
  }

  .product-class-item {
    position: relative;
  }

  .item-action {
    position: absolute;
    right: 0;
    font-size: 90%;
    z-index: 10;
    margin: 5px;
    /* background: rgb(0, 0, 0, 0.5) */
  }

  .item-action a {
    padding: 5px;
    color: cornflowerblue;
  }

  .content-action {
    padding: 10px 0;
    text-align: right;
  }

  .content-action a {
    padding: 4px;
    font-size: 90%;
    color: cornflowerblue;
  }
</style>